export const UNAVAILABLE_PRODUCT_OPTION = 'UNAVAILABLE_PRODUCT_OPTION';

export interface UnavailableProductOptionItem {
  productOptionId: number;
  exhibitionId: number | null;
  status: string;
}

export interface UnavailableProductOptionData {
  items: UnavailableProductOptionItem[];
}

const isUnavailableProductOptionItem = (
  item: unknown,
): item is UnavailableProductOptionItem => {
  if (!item || typeof item !== 'object') return false;
  const { productOptionId, exhibitionId, status } = item as Record<
    string,
    unknown
  >;
  return (
    typeof productOptionId === 'number' &&
    (exhibitionId === null || typeof exhibitionId === 'number') &&
    typeof status === 'string'
  );
};

export const isUnavailableProductOptionData = (
  data: unknown,
): data is UnavailableProductOptionData => {
  if (!data || typeof data !== 'object') return false;
  const { items } = data as { items?: unknown };
  return Array.isArray(items) && items.every(isUnavailableProductOptionItem);
};
